import { render } from "./ui-year-selector.vue?vue&type=template&id=0c0fc9fa&ts=true"
import script from "./ui-year-selector.vue?vue&type=script&lang=ts"
export * from "./ui-year-selector.vue?vue&type=script&lang=ts"

import "./ui-year-selector.vue?vue&type=style&index=0&id=0c0fc9fa&lang=less"

import exportComponent from "D:\\Projects\\aba\\aba-cabinet-front\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__